import type { SVGProps } from 'react';

const SvgBrandingWatermark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M23 3H1v18h22zm-2 16h-9v-6h9z" />
  </svg>
);
export default SvgBrandingWatermark;
